module.exports = __webpack_public_path__ + "static/img/coupon.7976cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/coupon.png
// module id = NxV3
// module chunks = 174